import { createAction, props } from '@ngrx/store';
import {ControlledInputs} from '../../../units/models/controlled-inputs';
import {ControlledInputUpdate} from '../../../units/models/controlled-input-update';
import {ControlledInputUpdateResponse} from '../../../units/models/controlled-input-update-response';

export const getControlledInputs = createAction(
  '[ControlledInputs] Get Controlled Inputs',
  props<{unitIds: number[]}>()
);
export const getControlledInputsSuccess = createAction(
  '[ControlledInputs/API] Get Controlled Inputs Success',
  props<{controlledInputs: ControlledInputs[]}>()
);
export const getControlledInputsFailure = createAction(
  '[ControlledInputs/API] Get Controlled Inputs Failure',
  props<{error: any}>()
);


export const updateControlledInput = createAction(
  '[ControlledInputs] Update Controlled Input',
  props<{data: ControlledInputUpdate}>()
);

export const updateControlledInputSuccess = createAction(
  '[ControlledInputs/API] Update Controlled Input Success',
  props<{data: ControlledInputUpdateResponse}>()
);
export const updateControlledInputFailure = createAction(
  '[ControlledInputs/API] Update Controlled Input Failure',
  props<{error: any}>()
);


export const cancelControlledInputUpdate = createAction(
  '[ControlledInputs] Cancel Controlled Input Update',
  props<{data: {unitId: number, inputName: string}}>()
);

export const cancelControlledInputUpdateSuccess = createAction(
  '[ControlledInputs/API] Cancel Controlled Input Update Success',
  props<{data: ControlledInputUpdateResponse}>()
);
export const cancelControlledInputUpdateFailure = createAction(
  '[ControlledInputs/API] Cancel Controlled Input Update Failure',
  props<{error: any}>()
);


export const wsControlledInputUpdateSuccess = createAction(
  '[ControlledInputs/API] WS Controlled Input Update Success',
  props<{data: ControlledInputs[]}>()
);


export type ControlledInputsActionsUnion = ReturnType<
  typeof getControlledInputs |
  typeof getControlledInputsSuccess |
  typeof getControlledInputsFailure |
  typeof updateControlledInput |
  typeof updateControlledInputSuccess |
  typeof updateControlledInputFailure |
  typeof cancelControlledInputUpdate |
  typeof cancelControlledInputUpdateSuccess |
  typeof cancelControlledInputUpdateFailure |
  typeof wsControlledInputUpdateSuccess
>;
